<template>
  <div class="mobile-page-contact">
    <div class="mobile-content-box">
      <div class="mobile-left">
        <div class="mobile-title" id="leftTitle1">Contact Us<span>.</span></div>
        <div
          class="mobile-title"
          id="leftTitle2"
          style="margin-bottom: 0"
        ></div>
      </div>
      <div class="mobile-right">
        <div class="mobile-item">
          <div class="mobile-title-box">
            <img src="@/assets/mobile/contact/icon1.png" alt="" />
            <div class="mobile-title">河北总部</div>
          </div>
          <div class="mobile-text">衡水市桃城区城市杰座A 座 11 层</div>
        </div>

        <div class="mobile-item">
          <div class="mobile-title-box">
            <img src="@/assets/mobile/contact/icon2.png" alt="" />
            <div class="mobile-title">北京分公司</div>
          </div>
          <div class="mobile-text">北京市房山区长阳镇溪雅苑一区12号1层</div>
        </div>
      </div>
    </div>
    <div class="mobile-footer-box">
      <div class="mobile-top">
        <div class="mobile-title1">聊一聊？相信我们都会感到相识恨晚</div>
        <div class="mobile-title2">
          您在哪里我们的服务就在哪里，全国范围内支持上门洽谈。
        </div>
      </div>
      <!-- <div class="mobile-center">
        <div class="mobile-title">合作咨询</div>
        <div class="mobile-content">
          <div class="mobile-tel-item">闫丽琴 18231817521</div>
          <div class="mobile-tel-item">冷建斐 18330855518</div>
          <div class="mobile-email-item">shanmuzhi@shanmuzhi .com</div>
        </div>
      </div> -->
      <div class="mobile-bottom">
        <div class="mobile-input-item">
          <div class="mobile-label">怎么称呼您？</div>
          <el-input
            class="elInput"
            v-model="name"
            placeholder="姓名"
          ></el-input>
        </div>

        <div class="mobile-input-item">
          <div class="mobile-label">如何联系您？</div>
          <el-input
            class="elInput"
            v-model="phone"
            placeholder="电话"
          ></el-input>
        </div>

        <div class="mobile-input-item mobile-need-item">
          <div class="mobile-label">您的项目需求有哪些？</div>
          <el-input
            class="elInput"
            style="
              background: rgba(255, 255, 255, 0.1) !important;
              border: none !important;
              font-weight: 400;
              font-size: 1.75rem;
              color: #ffffff;
            "
            v-model="content"
            placeholder="请填写您的项目需求"
            type="textarea"
            :rows="4"
          ></el-input>
        </div>

        <div class="mobile-sub-btn" @click="submit">提交</div>
      </div>
    </div>
    <div class="mobile-record-box">
      <div class="mobile-left">CopyRight @ 2017-2025 shanmuzhi.com Design</div>
      <div class="mobile-right" style="cursor: pointer" @click="toICP">
        All Rights Reserved 备案号：{{ ICPtext() }}
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/api/Utils';
import { pageApi } from '@/api';
export default {
  name: 'home',
  data() {
    return {
      name: '',
      phone: '',
      content: '',
    };
  },
  components: {
    // PageSearch
  },
  mounted() {
    this.$nextTick(() => {
      new this.Typed('#leftTitle1', {
        strings: ['Contact Us<span>.</span>'],
        typeSpeed: 100,
      });

      new this.Typed('#leftTitle2', {
        strings: ['素未谋面，却能心照不宣'],
        typeSpeed: 100,
      });
    });
  },
  created() {
    // console.log(this.$publicData)
  },
  methods: {
    async submit() {
      if (!this.name || !this.phone || !this.content) {
        this.$message.error('请填写完整信息');
        return;
      }
      if (!/^\d{11}$/.test(this.phone)) {
        this.$message.error('请填写正确的手机号码');
        return;
      }
      const res = await pageApi.submitMessage({
        name: this.name,
        phone: this.phone,
        content: this.content,
      });
      if (res.code === 200) {
        this.$message.success('提交成功');
        this.name = '';
        this.phone = '';
        this.content = '';
      } else {
        this.$message.error('提交失败');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-page-contact .mobile-content-box {
  background: url('~@/assets/mobile/contact/bg.png') no-repeat bottom center;
  background-size: 100%;
  width: 46.875rem;
  height: 62.9375rem;
  padding-top: 19.1875rem;
  padding-left: 4.25rem;
}

.mobile-page-contact .mobile-content-box .mobile-left {
  width: 22rem;
}

.mobile-page-contact .mobile-content-box .mobile-left .mobile-title {
  font-weight: bold;
  font-size: 1.875rem;
  color: #ffffff;
  margin-bottom: 1.6875rem;
  white-space: nowrap;
}

.mobile-page-contact .mobile-content-box .mobile-left .mobile-title span {
  font-size: 3rem;
  line-height: 1.875rem;
  color: #e3b281;
}

.mobile-page-contact .mobile-content-box .mobile-right {
  margin-top: 11.5625rem;
}

.mobile-page-contact .mobile-content-box .mobile-right .mobile-item {
  margin-bottom: 3.375rem;
  width: 16.75rem;
}

.mobile-page-contact
  .mobile-content-box
  .mobile-right
  .mobile-item
  .mobile-title-box {
  padding-bottom: 0.5625rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-page-contact
  .mobile-content-box
  .mobile-right
  .mobile-item
  .mobile-title-box
  img {
  width: 2.1875rem;
  height: 2.1875rem;
  margin-right: 0.8125rem;
}

.mobile-page-contact
  .mobile-content-box
  .mobile-right
  .mobile-item
  .mobile-title-box
  .mobile-title {
  font-weight: 400;
  font-size: 1.625rem;
  color: #ffffff;
}

.mobile-page-contact
  .mobile-content-box
  .mobile-right
  .mobile-item
  .mobile-text {
  font-weight: 400;
  font-size: 1.25rem;
  color: #ffffff;
  line-height: 1.9375rem;
  white-space: nowrap;
  padding-top: 1.25rem;
}

.mobile-page-contact .mobile-footer-box {
  border-top: 0.0625rem solid rgba(255, 255, 255, 0.1);
  padding: 1.5625rem 4.25rem 0 4.25rem;
}

.mobile-page-contact .mobile-footer-box .mobile-top .mobile-title1 {
  font-weight: 400;
  font-size: 1.875rem;
  color: #ffcfa0;
  line-height: 5.5625rem;
}

.mobile-page-contact .mobile-footer-box .mobile-top .mobile-title2 {
  font-weight: 400;
  font-size: 1.5rem;
  color: #ffffff;
  white-space: nowrap;
  opacity: 0.87;
}

.mobile-page-contact .mobile-footer-box .mobile-center .mobile-title {
  font-weight: 400;
  font-size: 1rem;
  color: #ffffff;
  opacity: 0.54;
  margin: 1.1875rem 0 0.75rem 0;
}

.mobile-page-contact .mobile-footer-box .mobile-center .mobile-content {
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffffff;
  line-height: 1.5rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.mobile-page-contact
  .mobile-footer-box
  .mobile-center
  .mobile-content
  .mobile-tel-item {
  margin-right: 1.125rem;
}

.mobile-page-contact
  .mobile-footer-box
  .mobile-center
  .mobile-content
  .mobile-email-item {
  margin-left: calc(2.9375rem - 1.125rem);
}

.mobile-page-contact .mobile-footer-box .mobile-bottom {
  margin-top: 2.375rem;
  padding-bottom: 3.4375rem;
}

.mobile-page-contact
  .mobile-footer-box
  .mobile-bottom
  .mobile-input-item
  .mobile-label {
  font-weight: 400;
  font-size: 1.625rem;
  color: #ffffff;
  margin: 1.8125rem 0 1.3125rem 0;
}
/deep/ .el-input {
  height: 4.375rem !important;
  font-weight: 400;
  font-size: 1.75rem;
}

/deep/ .el-input__inner {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: none !important;
  color: #ffffff !important;
  min-height: 4.375rem !important;
  font-weight: 400;
  font-size: 1.75rem;
}

.mobile-page-contact .mobile-footer-box .mobile-bottom .mobile-need-item {
  width: 38.9375rem;
}

.mobile-page-contact
  .mobile-footer-box
  .mobile-bottom
  .mobile-need-item
  .el-textarea__inner {
  color: #fff;
}

.mobile-page-contact .mobile-footer-box .mobile-bottom .mobile-sub-btn {
  width: 8.75rem;
  height: 3.75rem;
  background: #ffcfa0;
  border-radius: 0.375rem;
  font-weight: 400;
  font-size: 1.75rem;
  color: #512800;
  text-align: center;
  line-height: 3.75rem;
  margin: 1.6875rem auto 3.8125rem;
}

.mobile-page-contact .mobile-record-box {
  padding: 2.5625rem 0 2.6875rem 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 1.5rem;
  color: #ffffff;
  text-align: center;
  opacity: 0.2;
  border-top: 0.125rem dashed rgba(255, 255, 255, 0.4);
}

.mobile-page-contact .mobile-record-box .mobile-left {
  margin-bottom: 2.125rem;
}
</style>
